import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface DeleteStagedProceduralFileParams {
  matterId: string;
  uploadId: string;
  filename: string;
}

/**
 * Deletes a staged (temporary) procedural-timeline file from S3. Used when the
 * user cancels the upload modal before submitting.
 */
export const useDeleteStagedProceduralFile = () => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation<void, Error, DeleteStagedProceduralFileParams>(async ({ matterId, uploadId, filename }) => {
    const res = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/procedural-timeline/staged-files/${uploadId}?filename=${encodeURIComponent(filename)}`,
      getFetchConfig({ method: FetchMethod.DELETE }),
    );
    if (!res.ok && res.status !== 204) {
      throw new Error('Failed to delete staged file');
    }
  });
};
